import { styled as t, Box as c } from "@mui/material";
import i from "@mui/material/Typography";
import { jsxs as p, jsx as e } from "react/jsx-runtime";
const h = t(c)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 10px;
`, x = t(i)`
  & {
    font-size: 24px;
    line-height: 30px;
    font-weight: 400;
  }
  color: white;
`, a = t(i)`
  & {
    font-size: 14px;
    line-height: 20px;
    font-weight: 300;
  }
  color: #8e8e8e;
  text-align: center;
`, g = (o) => {
  const {
    children: n,
    className: l,
    subtitle: r,
    title: s
  } = o;
  return /* @__PURE__ */ p(h, {
    className: l,
    children: [/* @__PURE__ */ e(x, {
      children: s
    }), n, /* @__PURE__ */ e(a, {
      children: r
    })]
  });
};
export {
  g as default
};
//# sourceMappingURL=PopupTitle.js.map
